import React from 'react';
import { MapPin } from 'lucide-react';
import { useTheme } from '../../../contexts/ThemeContext';
import { shortenAddress } from '../../../utils/bookingTimeUtils';

/**
 * LocationOption Component
 *
 * Displays a single location option in a dropdown with icon, name, and address.
 * Icons are color-coded: green for start, red for end, blue for intermediate stops.
 *
 * @param {Object} props
 * @param {'start'|'end'|'stop'} props.type - Location type determining icon color
 * @param {string} props.name - Location name to display
 * @param {string} props.address - Full address (will be shortened)
 * @param {Function} props.t - Translation function from i18n
 */
const LocationOption = ({ type, name, address, t }) => {
  const { background, text, cn } = useTheme();

  return (
    <div className={cn("flex items-center py-2 px-3", "hover:bg-gray-50 dark:hover:bg-gray-700")}>
      <MapPin className={`w-4 h-4 mr-2 ${type === 'start' ? 'text-green-500' : type === 'end' ? 'text-red-500' : 'text-blue-500'}`} />
      <div className="flex-1 min-w-0">
        <div className={cn("font-medium text-sm", text.primary)}>
          {type === 'start' ? t('start') : type === 'end' ? t('end') : ` ${name}`}
        </div>
        <div className={cn("text-sm truncate", text.secondary)}>
          {shortenAddress(address)}
        </div>
      </div>
    </div>
  );
};


export default React.memo(LocationOption);
